"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ = require("./");

const wrapRootElement = ({
  element
}) => /*#__PURE__*/_react.default.createElement(_.MediaContextProvider, null, element);

var _default = wrapRootElement;
exports.default = _default;